import React from 'react';
import { useAudio } from '../../contexts/AudioContext';

function formatTime(seconds) {
  if (!seconds || isNaN(seconds)) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function ProgressBar() {
  const { stationData, elapsed } = useAudio();
  const duration = stationData?.now_playing?.duration || 0;
  const progress = duration > 0 ? (elapsed / duration) * 100 : 0;

  return (
    <div className="w-full space-y-2" data-testid="progress-bar-container">
      {/* Progress bar track */}
      <div 
        className="relative h-2 rounded-full overflow-hidden"
        style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
      >
        {/* Progress fill */}
        <div 
          className="h-full rounded-full transition-all duration-1000 ease-linear"
          style={{ 
            width: `${progress}%`,
            background: 'linear-gradient(90deg, #8B5CF6, #22C55E)'
          }}
        />
      </div>

      {/* Time display */}
      <div className="flex justify-between text-xs" style={{ color: 'var(--text-muted)' }}>
        <span data-testid="elapsed-time">{formatTime(elapsed)}</span>
        <span data-testid="remaining-time">-{formatTime(duration - elapsed)}</span>
      </div>
    </div>
  );
}
